<script>
import { mapGetters } from 'vuex';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useAccount } from 'dashboard/composables/useAccount';
import Banner from 'dashboard/components/ui/Banner.vue';

export default {
  components: { Banner },
  setup() {
    const { isAdmin } = useAdmin();
    const { accountId } = useAccount();

    return { accountId, isAdmin };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
    }),
    billing() {
      const account = this.getAccount(this.accountId);
      return account?.billing || {};
    },
    isTrialExpired() {
      return this.billing.enabled && this.billing.trial_expired;
    },
    isOnTrial() {
      return this.billing.enabled && this.billing.on_trial;
    },
    shouldShowBanner() {
      return this.isTrialExpired || this.isOnTrial;
    },
    colorScheme() {
      return this.isTrialExpired ? 'alert' : 'primary';
    },
    bannerMessage() {
      if (this.isTrialExpired) {
        return this.$t('BILLING_SETTINGS.TRIAL.EXPIRED');
      }

      const { trial_limits: trialLimits } = this.billing;
      const daysLeft = this.$t('BILLING_SETTINGS.TRIAL.DAYS_LEFT_BANNER', {
        count: this.billing.trial_days_left,
      });

      if (!trialLimits) {
        return daysLeft;
      }

      const caps = this.$t('BILLING_SETTINGS.TRIAL.CAPS_SUMMARY', {
        agents: trialLimits.agents,
        inboxes: trialLimits.inboxes,
        tickets: trialLimits.tickets,
      });

      return `${daysLeft} ${caps}`;
    },
    actionButtonMessage() {
      return this.$t('BILLING_SETTINGS.PLANS.CHOOSE');
    },
  },
  methods: {
    routeToPlans() {
      this.$router.push({
        name: 'billing_settings_plans',
        params: { accountId: this.accountId },
      });
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShowBanner"
    :color-scheme="colorScheme"
    :banner-message="bannerMessage"
    :action-button-label="isAdmin ? actionButtonMessage : ''"
    :has-action-button="isAdmin"
    @primary-action="routeToPlans"
  />
</template>
